<template>
  <div>
    <b-form-group label="تخفیف">
      <Discount v-model="realValue"/>
    </b-form-group>
  </div>
</template>

<script>
import VarietyInformationImpl from '@@/core/components/product/varieties/VarietyInformation/VarietyInformationImpl'
import Gift from '@@/core/components/product/shared/Gift/Gift'

export default {
  components: {Gift},
  extends: VarietyInformationImpl
}
</script>

<style scoped>

</style>
